import {
  Button,
  Chip,
  Fade,
  Input,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";

const HigherLevelBachelor = () => {
  const [clicked, setClicked] = useState(true);
  const [text, setText] = useState(null);

  const [grade12, setgrade12] = useState(false);
  // const [pg,setpg] = useState(false);
  const [ud, setud] = useState(false);
  // const [pd,setpd] = useState(false);

  const [errMessage, setErrMessage] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [board, setBoard] = useState(null);

  const handleClick = (event) => {
    console.log(event);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    setBoard(e.target.innerText);
    // console.log(e.target.innerText)
    setAnchorEl(null);
  };

  console.log(anchorEl);

  const navigate = useNavigate();

  //   const handleClickUG = (e) => {
  //     setText(e.target.innerText);
  //    // setug(true)

  //     setpg(false)
  //     setud(false)
  //     setpd(false)
  //   };

  //   const handleClickPG = (e) => {
  //     setText(e.target.innerText);
  //     setpg(true)

  //     setug(false)
  //     setud(false)
  //     setpd(false)
  //   };

  const handleClickUD = (e) => {
    setText(e.target.innerText);
    setud(true);

    setgrade12(false);
    //    setug(false)
    //    setpg(false)
    //    setpd(false)
  };

  const handleClickGrade12 = (e) => {
    setText(e.target.innerText);
    setgrade12(true);

    //    setug(false)
    //    setpg(false)
    setud(false);
  };

  const handleInputChange = (e) => {
    console.log(e.target.value);
    if (e.target.value < 33 || e.target.value > 100) {
      setErrMessage(
        "Your percentage is low atleast 33% needed to proceed ahead and below 100%"
      );
    } else {
      setErrMessage(true);
    }
  };

  const handleClickButton = () => {
    navigate("/majorpursue");
  };

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <div>
                  <Typography
                    color="secondary"
                    fontSize={28}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin"
                  >
                    What is your highest education level?
                  </Typography>
                </div>

                <div className="p-20 flex items-center justify-center">
                  <Stack direction="row" spacing={1} className="crad" size={18}>
                    <Chip
                      sx={{fontSize:"18px", color:"white"}}
                      className="p-20 rounded-full font-bold border-3 text-14"
                      size="large"
                      label="Grade 12"
                      style={{
                        backgroundColor: grade12 ? "#603aa2" : "#c59bdb",
                        fontSize: "50",
                        margin: "2%",
                      }}
                      variant={grade12 ? "filled" : "outlined"}
                      onClick={(e) => handleClickGrade12(e)}
                    />
                    {/* <Chip
                className="p-20 rounded-full font-bold border-3 text-14"
                label="Undergraduate Diploma"
                size="medium"
                style={{ backgroundColor :  pg ? "#00BFFF" : 'white'}}
                variant={pg ? 'filled' : 'outlined'}
                onClick={(e) => handleClickPG(e)}
              /> */}
                    <Chip
                      className="p-20 rounded-full font-bold border-3 text-14"
                      sx={{fontSize:"18px", color:"white"}}
                      label="Undergraduate Diploma"
                      size="large"
                      style={{
                        backgroundColor: ud ? "#603aa2" : "#c59bdb",
                        margin: "2%",
                      }}
                      variant={ud ? "filled" : "outlined"}
                      onClick={(e) => handleClickUD(e)}
                    />
                    {/* <Chip
                className="p-20 rounded-full font-bold border-3 text-14"
                label="Postgarduate Diploma"
                size="medium"
                style={{ backgroundColor :  pd ? "#00BFFF" : 'white'}}
                variant={pd ? 'filled' : 'outlined'}
                onClick={(e) => handleClickPD(e)}
              /> */}
                  </Stack>
                </div>

                {grade12 && (
                  <>
                    <div className="countryPicker" >
                      <Button
                        className="crad"
                        id="fade-button"
                        aria-controls={open ? "fade-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        variant="outlined"
                      >
                        {board || "Select Board"}
                      </Button>
                      <Menu
                      sx={{justifyContent:"center"}}
                      style={{justifyContent:"center"}}
                        className="crad"
                        id="fade-menu"
                        MenuListProps={{
                          "aria-labelledby": "fade-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Fade}
                      >
                        <MenuItem sx={{justifyContent:"center"}} value="IG" onClick={(e) => handleClose(e)}>
                          IG
                        </MenuItem>
                        <MenuItem onClick={(e) => handleClose(e)}>
                          ICSE
                        </MenuItem>
                        <MenuItem onClick={(e) => handleClose(e)}>
                          CBSE
                        </MenuItem>
                        <MenuItem onClick={(e) => handleClose(e)}>
                          State
                        </MenuItem>
                      </Menu>
                    </div>

                    <div className="crad">
                      <Typography
                      color="light"
                      fontSize={20}
                      align="center"
                       className="d-flex mt-5 items-center  justify-center crad equalMargin">
                        What is your expected or gained percentage in {text} ?
                      </Typography>
                    </div>

                    <div className="flex flex-col justify-center ">
                      <center>
                        <Input
                        className="equalMargin"
                          type="number"
                          size="small"
                          // inputProps={{ maxLength: 4 }}
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#5D3FD3",
                          }}
                          onChange={(e) => handleInputChange(e)}
                        ></Input>
                      </center>
                      <Typography
                         color="light"
                         fontSize={18}
                         align="center"className="d-flex mt-5 items-center  justify-center crad equalMargin">
                        {errMessage}
                      </Typography>
                    </div>
                  </> 
                )}

                {ud && (
                  <>
                    <div>
                      <Typography  color="light"
                      fontSize={20}
                      align="center"className="d-flex mt-5 items-center  justify-center crad equalMargin">
                        What is your expected or gained percentage in {text} ?
                      </Typography>
                    </div>

                    <div className="flex flex-col justify-center">
                      <center>
                        <Input
                        className="equalMargin"
                          type="number"
                          size="small"
                          onChange={(e) => handleInputChange(e)}
                          style={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#5D3FD3",
                          }}
                        ></Input>
                      </center>
                      <Typography  color="light"
                      fontSize={18}
                      align="center"className="d-flex mt-5 items-center  justify-center crad equalMargin">
                        {errMessage}
                      </Typography>
                    </div>
                  </>
                )}

                <div className="d-flex mt-5 items-center  justify-center crad">
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleClickButton}
                    style={{ backgroundColor: "#603aa2", fontSize: "18px" }}
                    disabled={errMessage == true ? false : true}
                  >
                    Continue
                  </Button>
                </div>

                {/* 
          { errMessage != null &&
            <div className="flex justify-center mt-20">
              <Button
                variant="contained"
                size="large"
                onClick={handleClickButton}
                color="primary"
                disabled={(errMessage ? true : false)}
              //disabled={ ((errMessage ? true : false) || ( (grade12 || ud) ? false : true)) }
              // disabled={( grade12 || ud) ? !(errMessage == null ? true : false) : true }
              >
                Continue
              </Button>
            </div>
          } */}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default HigherLevelBachelor;
